/**
 * Admin Token Mapping route segment, relative to the Admin domain. This package
 * owns the Token Mapping URL: `tokenMappingConfig` builds its route path, nav url
 * and WS-login skip path from these, so the three can't drift apart.
 *
 * The URL is literal: the app mounts the Admin domain at `adminRoutes.path`,
 * and the dashboard's admin feature drift test keeps it resolving to the route
 * the app registers for it. This module has no imports, so the boot-path feature
 * config can read it without loading any UI.
 */
export const TOKEN_MAPPING_ROUTE_PATH = 'token-mapping';

/** Absolute URL of the admin Token Mapping list page. */
export const TOKEN_MAPPING_LIST_URL = '/admin/token-mapping';
